import { useQuery } from '@tanstack/react-query';
import { PromoItemZmsView } from '@/features/promotion/components/PromoItemZmsView';
import type {
  PromoDrillParams,
  PromoDrillSearchBox,
} from '@/features/promotion/types/promotion.types';
import { distributedMpItemQueryOptions } from '../api/marketPromotion.api';

const UNKNOWN_PROMOTION_TITLE = 'Promotion';

interface MpItemZmsPageProps {
  promoItemId: number;
  zmSearch: PromoDrillParams;
  searchBox: PromoDrillSearchBox;
}

export function MpItemZmsPage({ promoItemId, zmSearch, searchBox }: MpItemZmsPageProps) {
  const promotionQuery = useQuery(distributedMpItemQueryOptions(promoItemId, zmSearch));
  const title = promotionQuery.isLoading
    ? undefined
    : (promotionQuery.data?.name ?? UNKNOWN_PROMOTION_TITLE);

  return (
    <PromoItemZmsView
      unit="marketPromotion"
      promoItemId={promoItemId}
      zmSearch={zmSearch}
      searchBox={searchBox}
      title={title}
    />
  );
}
